// assets
import Arrow from "assets/icons/forward.svg";
import Check2 from "assets/icons/pop-check.svg";
import Cancel from "assets/icons/sm-x.svg";
import Back from "assets/svg/back-arrow.svg";
import Load from "assets/svg/other/loading2.svg";
import Header from "components/dashHeader";
// components
import Sidemenu from "components/sidemenu";
//css
import "pages/styles/dashboard/P2P.css";
import React, { Component, createRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import styled from "styled-components";
//import { logger } from "util/logger";
import { get, post } from "util/axiosLib";
import { logger } from "util/logger";
import { getParameterByName, isEmpty } from "util/utils";

const fee = 0.008;
const loadedFee = 1 - fee;

export default function P2pBuyTrades(props) {
  const { store, dispatch } = useStore();
  const history = useHistory();

  return (
    <P2PBuy
      {...props}
      view={props.view}
      localSocket={store?.localSocket}
      store={store}
      dispatch={dispatch}
      history={history}
    />
  );
}

class P2PBuy extends Component {
  state = {
    popUpClicked: false,
    summaryClicked: false,
    tradeData: [],
    isTyping: false,
    listingKey: "listing",
    isSubmitting: false,
    isFillable: false,
  };

  qtyRef = createRef();

  handleSubmit = (event) => {
    event.preventDefault();

    const errmsg = document.getElementById("error-info2");
    errmsg.classList.remove("err-auth-on");
    this.setState({ incorrectError: "" });

    if (
      (this.state.tradeOption && this.state.tradeOption.minimumFilling) ||
      (this.state.tradeOption && this.state.tradeOption.maximumFilling)
    ) {
      if (
        this.state.quantity < this.state.tradeOption.minimumFilling ||
        this.state.quantity > this.state.tradeOption.maximumFilling
      ) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({
          incorrectError: "Value either less than or more than trade filling",
        });
      } else {
        this.setState({ summaryClicked: true });
      }
    } else {
      this.setState({ summaryClicked: true });
    }

    // try {
    // } catch (err) {

    // }
  };

  handleRemove = (event) => {
    event.preventDefault();

    this.setState({ popUpClicked: false });
    this.setState({ popUpRemove: true });
    // const element = document.getElementById("rem-box");
    // element.classList.toggle("rem-box-off");
    setTimeout(function () {
      document.querySelector("#rem-box").style.display = "none";
    }, 1000);
  };

  loadTrade = async () => {
    try {
      const token = this.props.store?.token;

      // const tradeUrl = window.location.search
      // const tradeId = tradeUrl.substr(1)
      const tradeUrl = window.location.pathname;
      const tradeId = tradeUrl.substr(18).split("/")[0];

      if (!tradeId) {
        return this.props.history.push("/dashboard/p2p");
      }

      const listingType = getParameterByName("type");

      const listingKey = listingType === "flexi" ? `flexiListing` : "listing";

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      const getTradeReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/${listingKey}/${tradeId}`,
        headers
      );

      this.setState({
        tradeData: getTradeReq.data.data,
        tradeOption: getTradeReq.data.data.tradeOption,
        tradeCost: getTradeReq.data.data.totalCost.$numberDecimal,
        tradeValue: getTradeReq.data.data.currentVolume.$numberDecimal,
        tradeId,
        isLoaded: true,
        listingKey,
      });

      logger(this.state.tradeData);

      return Promise.resolve(true);
    } catch (err) {
      const errData = err.response;
      if (errData?.status === 403 || errData?.status === 401) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Token expired, please login again." });

        this.props.localSocket?.emit("LOGOUT");
      }
    }
  };

  handleSummary = async (event) => {
    event.preventDefault();
    try {
      const token = this.props.store.token;
      const tradeId = this.state.tradeId;
      this.setState({ isSubmitting: true });

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      const buyDetails = {
        volume: Number(this.state.quantity),
      };
      const buyTradeReq = await post(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/${this.state.listingKey}/${tradeId}/buy`,
        buyDetails,
        headers
      );

      this.setState({
        summaryClicked: false,
        popUpClicked: true,
        isSubmitting: false,
        isLoaded: true,
      });

      //this.setState({ popUpClicked: false });

      logger(buyTradeReq);

      return Promise.resolve(true);
    } catch (err) {
      logger("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        this.setState({
          errorMessage: Object.values(errData.data.error),
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");

        if (errData?.status === 403 || errData?.status === 401) {
          const errmsg = document.getElementById("error-info2");
          errmsg.classList.add("err-auth-on");
          this.setState({
            incorrectError: "Token expired, please login again.",
            isSubmitting: false,
          });
        }
      } else {
        this.setState({
          otherError: "Something went wrong",
          isSubmitting: false,
        });
      }
    } finally {
      this.loadTrade();
    }
  };

  autoFit = () => {
    const trData = this.state?.tradeData;
    const qty = this.state?.quantity;

    const currentVolume = Number(trData?.currentVolume?.$numberDecimal);
    if (!isEmpty(trData) && qty) {
      let autoFitter = { value: qty, key: "initial" };

      if (!trData.tradeOption || !trData.tradeOption?.acceptPartialFilling) {
        if (!isNaN(currentVolume)) {
          const newQty = Number(currentVolume / 1);
          this.setState({
            quantity: newQty,
            convertedValue: newQty
              ? Number(Number(newQty * loadedFee).toFixed(8))
              : 0,
          });
          this.qtyRef.current.value = newQty;
          return;
        }
      } else {
        const trD = trData?.tradeOption;
        if (trD) {
          if (trD?.minimumFilling && qty < trD?.minimumFilling) {
            autoFitter.value = trD.minimumFilling;
            autoFitter.key = "minimumFilling";
          }
          if (
            trD?.maximumFilling &&
            qty > trD?.maximumFilling &&
            currentVolume >= trD?.maximumFilling
          ) {
            autoFitter.value = trD.maximumFilling;
            autoFitter.key = "maximumFilling";
          }

          if (trD?.exactFilling && currentVolume >= trD?.exactFilling) {
            autoFitter.value = trD.exactFilling;
            autoFitter.key = "exactFilling";
          }

          if (!isNaN(currentVolume)) {
            const newQty = Math.min(
              Number(autoFitter.value / 1),
              currentVolume
            );
            this.setState({
              quantity: newQty,
              convertedValue: newQty
                ? Number(Number(newQty * loadedFee).toFixed(8))
                : 0,
            });
            this.qtyRef.current.value = newQty;
            return;
          }
        } else {
          const newQty = Math.min(qty, currentVolume);
          this.setState({
            quantity: newQty,
            convertedValue: newQty
              ? Number(Number(newQty * loadedFee).toFixed(8))
              : 0,
          });
          this.qtyRef.current.value = newQty;
          return;
        }
      }
    }
  };

  handleInputChange = async (event) => {
    const target = event.target;
    const name = target.name;

    await this.setState({
      [name]: target.value,
      isTyping: target.value ? true : false,
      convertedValue: target.value
        ? Number(Number(target.value * loadedFee).toFixed(8))
        : 0,
    });

    const errmsg = document.getElementById("error-info2");
    errmsg.classList.remove("err-auth-on");
    this.setState({ incorrectError: " " });

    if (name === "quantity") {
      const numberRegex = /(?=[a-zA-Z])/;
      if (numberRegex.test(event.target.value) || event.target.value < 0) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Please enter only valid numbers" });
      }

      if (this.state.quantity > 0) {
        const ebtn = document.getElementById("createBtn");
        await ebtn.classList.remove("e-disable");
      } else {
        const ebtn = document.getElementById("createBtn");
        await ebtn.classList.add("e-disable");
      }
    }
  };

  componentDidMount() {
    this.loadTrade();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.quantity !== this.state.quantity) {
      const { tradeData } = this.state;
      let tradeCost = 0;
      if (tradeData) {
        if (this.state.quantity) {
          const qty = this.state.quantity;
          const actualFillable = Number(Number(qty * loadedFee).toFixed(8));
          const minimumFilling = tradeData.tradeOption?.acceptPartialFilling
            ? tradeData.tradeOption.exactFilling ||
              tradeData.tradeOption?.minimumFilling
            : tradeData.volume.$numberDecimal;
          if (
            actualFillable &&
            actualFillable >= Number(tradeData?.totalCost)
          ) {
            tradeCost = Number(tradeData?.totalCost?.$numberDecimal);
          } else {
            const unitCost = tradeData?.tradeOption?.unitCost || 0;
            if (!unitCost) tradeCost = tradeData?.totalCost?.$numberDecimal;
            else {
              tradeCost = Number(
                Number.parseFloat(
                  Number(Number(actualFillable) * unitCost).toFixed(8)
                ).toFixed(8)
              );
            }
          }
          if (!isNaN(tradeCost)) {
            this.setState({
              sellersConvertedValue: Number(tradeCost).toLocaleString(),
              isFillable: Number(qty) >= Number(minimumFilling),
            });
          } else {
            this.setState({ isFillable: false });
          }
        }
      }
    }
  }

  render() {
    const currentPage = "P2P";
    const { convertedValue, isTyping, tradeData, isFillable, isSubmitting } =
      this.state;
    const listingStatus = String(tradeData?.adsStatus).toLowerCase();

    return (
      <StyledP2PTrade>
        <Sidemenu currentPage={currentPage} />
        <Header />

        {this.state.popUpClicked ? (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2 className="uppercase">
                  {this.state.quantity + " " + this.state.tradeData.sourceUnit}
                </h2>
                <p className="popup-success">Purchased Successfully!</p>
                <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p>
                {/* {document.querySelector('#rem-box').style.display = "block"} */}
              </div>
            </section>
          </div>
        ) : null}
        {this.state.popUpRemove === true && (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeOut "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__backOutUp">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2 className="uppercase">
                  {this.state.tradeValue +
                    " " +
                    this.state.tradeData.sourceUnit}
                </h2>
                <p className="popup-success">Purchased Successfully!</p>
                <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p>
              </div>
            </section>
          </div>
        )}

        {this.state.summaryClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top">
                  <h2 className="">Summary</h2>
                  <img
                    onClick={() => this.setState({ summaryClicked: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Coin </p>
                  <p className="bold">
                    {" "}
                    {String(
                      this.state?.tradeData?.sourceUnit
                    ).toUpperCase()}{" "}
                  </p>
                </div>
                <div className="sc-items">
                  <p className="sc-item-title"> Quantity you want to buy </p>
                  <p className="bold">
                    {" "}
                    {Number(
                      Number(this.state.quantity * loadedFee).toFixed(8)
                    )}{" "}
                  </p>
                </div>
                {this.state.tradeOption !== undefined && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Rate </p>
                    <p className="bold">
                      {`
                      ${
                        this.state?.tradeOption?.unitCost
                      } ${tradeData?.destinationUnit.toUpperCase()} / 1 ${tradeData?.sourceUnit.toUpperCase()}
                `}
                    </p>
                  </div>
                )}
                {this.state.tradeOption !== undefined && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Total Cost to Pay </p>
                    <p className="bold">
                      {" "}
                      {Number(
                        this.state.tradeOption.unitCost * this.state.quantity
                      ).toLocaleString() +
                        " " +
                        this.state.tradeData.destinationUnit.toUpperCase()}{" "}
                    </p>
                  </div>
                )}
                {false && (
                  <div className="sc-items">
                    <p className="sc-item-title"> Total Ad Cost </p>
                    <p className="bold">
                      {" "}
                      {Number(this.state.tradeCost).toLocaleString() +
                        " " +
                        this.state.tradeData.destinationUnit.toUpperCase()}{" "}
                    </p>
                  </div>
                )}
                <div className="sc-items">
                  <p className="sc-item-title"> Fee charged</p>
                  <p className="bold">
                    {`${Number(
                      Number(this.state.quantity * fee).toFixed(8)
                    )} ${tradeData?.sourceUnit.toUpperCase()}`}
                  </p>
                </div>

                <button
                  onClick={this.handleSummary}
                  className="summaryclicked-btn"
                  disabled={isSubmitting}>
                  Submit
                </button>
                {isSubmitting ? (
                  <div
                    className="loading-ab"
                    id="load"
                    style={{ position: "relative", width: "unset" }}>
                    <img src={Load} alt="loading" />
                  </div>
                ) : null}
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn">
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        <section className="p2p">
          <div className="p2p-container">
            <div className="p2p-content">
              <Link to="/dashboard/p2p">
                <img src={Back} className="w-backarrow" alt="back" />
              </Link>
              <h1> Buy </h1>
              <div className="p2p-nav">
                <Link to="/dashboard/p2p" className="right-e">
                  <p className="ash"> P2P </p>{" "}
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold"> Buy</span>
                </p>
              </div>
              <div
                id="error-info2"
                className="err-auth zindex animate__animated animate__slideInDown">
                <p>
                  <strong>{this.state.incorrectError}</strong>
                </p>
              </div>
              {this.state.isLoaded ? (
                <div className="p2p-boxes">
                  {listingStatus === "open" && (
                    <div className="p2p-left-box right-e">
                      <form
                        onSubmit={this.handleSubmit}
                        className="p2p-buy-form">
                        <div className="p2p-inputs">
                          <p>
                            <span className="uppercase">
                              {this.state?.tradeData?.sourceUnit + " "}
                            </span>
                            quantity you want to buy
                          </p>
                          <input
                            type="text"
                            name="quantity"
                            ref={this.qtyRef}
                            disabled={listingStatus !== "open"}
                            onChange={this.handleInputChange}
                            // value={this.state.quantity || '0.00'}
                            placeholder="0.00"
                          />
                          {!isNaN(convertedValue) && isTyping ? (
                            <div className="action-helper">
                              <div className="converted-value">
                                <p>
                                  <strong>What you will get: </strong>{" "}
                                  <em>
                                    {convertedValue || 0}{" "}
                                    {String(
                                      this.state?.tradeData?.sourceUnit
                                    ).toUpperCase()}
                                  </em>
                                </p>
                              </div>
                              <button
                                className="border border-blue"
                                // disabled={listingStatus !== "open"}
                                onClick={(e) => {
                                  if (listingStatus !== "open") {
                                    window.prompt("Listing is closed");
                                    return;
                                  }
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.autoFit();
                                }}>
                                Autofit
                              </button>
                            </div>
                          ) : null}
                        </div>
                        {/* <div className="p2p-inputs">
                                            <p>Wallet</p>
                                            <input  type="text" placeholder="Your Bitmama Wallet"/>
                                        </div> */}
                        <button
                          id="createBtn"
                          className="p2p-submit e-disable"
                          htmltype="submit"
                          disabled={
                            !this.state.quantity ||
                            !isFillable ||
                            listingStatus !== "open" ||
                            isSubmitting
                          }>
                          Buy
                        </button>
                      </form>
                    </div>
                  )}
                  <div className="p2p-right-box">
                    <p className="ad-info-title green bold">Ad Listing Info</p>
                    <div className="p2p-ad-info">
                      <p>Status</p>
                      <p className="bold uppercase">
                        <span
                          className={`${
                            listingStatus === "open" ? "green" : "red"
                          } uppercase`}>
                          {String(listingStatus).toUpperCase()}
                        </span>
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Seller</p>
                      <p className="bold">
                        {String(
                          this.state.tradeData.userData?.username
                        ).toLowerCase()}
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Coin</p>
                      <p className="bold uppercase">
                        {this.state.tradeData.sourceUnit}
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Quantity</p>
                      <p className="bold uppercase">{this.state.tradeValue}</p>
                    </div>
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.unitCost !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Rate</p>
                          <p className="bold">
                            {this.state.tradeOption.unitCost}
                            <span className="green uppercase">
                              {" "}
                              {String(
                                this.state.tradeData.destinationUnit
                              ).toUpperCase()}
                            </span>
                            <span className="">
                              {" "}
                              / 1{" "}
                              {String(
                                this.state?.tradeData?.sourceUnit
                              ).toUpperCase()}
                            </span>
                          </p>
                        </div>
                      )}
                    {!this.state.tradeOption && (
                      <div className="p2p-ad-info">
                        <p>Price</p>
                        <p className="bold">
                          {Number(this.state.tradeCost).toLocaleString()}
                          <span className="green uppercase">
                            {" "}
                            {this.state.tradeData.destinationUnit}{" "}
                          </span>
                        </p>
                      </div>
                    )}
                    {this.state.tradeOption !== undefined && (
                      <div className="p2p-ad-info">
                        <p>Accepts Partial Filling</p>
                        <p className="bold">Yes</p>
                      </div>
                    )}
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.minimumFilling !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Minimum Filling</p>
                          <p className="bold">
                            {this.state.tradeOption.minimumFilling}
                          </p>
                        </div>
                      )}
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.maximumFilling !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Maximum Filling</p>
                          <p className="bold">
                            {this.state.tradeOption.maximumFilling}
                          </p>
                        </div>
                      )}
                    {tradeData?.p2pType === "flexi" && (
                      <div className="p2p-ad-info">
                        <p>Timeout</p>
                        <p className="bold uppercase">
                          <span
                            className={`${
                              listingStatus === "open" ? "green" : "red"
                            } uppercase`}>
                            {String(tradeData?.timeout)} Minutes
                          </span>
                        </p>
                      </div>
                    )}
                    <div className="p2p-ad-info">
                      <p>Location</p>
                      <p className="bold">{this.state.tradeData.country}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="loading-a" id="load">
                  <img src={Load} alt="loading" />
                </div>
              )}
            </div>
          </div>
        </section>
      </StyledP2PTrade>
    );
  }
}

export const StyledP2PTrade = styled.div`
  .loading-ab {
    margin-top: 1rem;
    img {
      width: 2rem;
    }
  }
  .p2p-inputs {
    margin-bottom: 1rem;
  }
  .p2p-left-box {
    min-height: 380px;
  }
  select.hw-drop {
    width: 325px;
  }
  .converted-value {
    margin: 1rem 0;
  }
  .action-helper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 325px;

    @media (max-width: 800px) {
      max-width: 75vw;
    }

    button {
      padding: 0.25rem 0.5rem;
      border-radius: 10px;
      border: 0.5px solid #1e1e1e;
    }
  }
`;
